import { gql } from '@apollo/client/core'

export const COLLECT_DETAILS_SUMMARY = gql`
query CollectDetailsSummary($input: PricingSummaryInputGraphql, $filters: CollectGraphqlFilters, $isAdmin: Boolean!) {
  collects(filters: $filters) {
    __typename
    collection {
      id
      isInvoiceable @include(if: $isAdmin) {
        errors
        alreadyInvoiced
        result
      }
      ...CollectPricingSummaryGraphql
    }
  }
}
`

export const COLLECTS_QUERY_SINGLE = gql`
query CollectSingle($pagination: PaginationArgs!, $filters: CollectGraphqlFilters, $isAdmin: Boolean!) {
  collects(pagination: $pagination, filters: $filters) {
    collection {
      ...AdminFields @include(if: $isAdmin)
      notes
      status
      id
      transportPrice
      startsAt
      endsAt
      licensePlate
      missingInformations
      notifications {
        wrNotifiedAt
        wpCollectUpdated
        wpDocumentsReadyNotifiedAt
        wrCollectConfirmedNotifiedAt
      }
      pricingSummary {
        ready
      }
      npsRating {
        additionalDetails
        rating
      }
      BSDs {
        count
        # collection {
        #   id
        #   tdState
        #   state
        # }
      }
      client {
        name
        id
      }
      collectedContainers {
        collection {
          id
          quantity
          treatmentCode
          siret
          unit
          missingInformations
          documents {
            collection {
              signedUrl
              name
              type
              id
              extension
              ... on CollectedContainerDocumentGraphql {
                subtype
              }
              client {
                id
              }
            }
          }
          container {
            name
            id
          }
          material {
            id
            name
            documents {
              collection {
                signedUrl
                name
                id
                client {
                  id
                }
              }
            }
            pricingForCurrentRecycler {
              id
              price
              vat
            }
          }
        }
      }
      recycler {
        id
        name
      }
    }
  }
}
`

export const COLLECTS_QUERY_LIST = gql`
query CollectList($pagination: PaginationArgs!, $filters: CollectGraphqlFilters) {
  collects(pagination: $pagination, filters: $filters) {
    count
    collection {
      status
      id
      isRoundStop
      startsAt
      endsAt
      createdAt
      notes
      npsRating {
        additionalDetails
        rating
      }
      round {
        id
        publicId
      }
      recycler {
        id
        name
      }
      client {
        name
        id
        organization {
          id
        }
      }
      collectedContainers {
        collection {
          id
          documents {
            collection {
              signedUrl
              id
              name
            }
          }
          material {
            id
            name
          }
        }
      }
    }
  }
}
`

export const CREATE_COLLECT_MUTATION = gql`
mutation CreateCollect($input: CreateCollectGraphql!) {
  createCollect(input: $input) {
    id
    isRoundStop
    collectedContainers {
      collection {
        id
        material {
          id
          documents {
            collection {
              signedUrl
            }
          }
        }
        container {
          id
        }
      }
    }
  }
}
`

export const UPDATE_COLLECT_QUERY = gql`
mutation UpdateCollectInformations($input: UpdateCollectInformationsGraphql!) {
  updateCollectInformations(input: $input) {
    id
    status
    startsAt
    endsAt
    notes
    licensePlate
    transportPrice
    truckRotationCount
    referent {
      firstName
      id
      lastName
    }
  }
}
`

export const BO_COLLECTS_QUERY_LIST = gql`
query BOCollectList($pagination: PaginationArgs!, $filters: CollectGraphqlFilters) {
  collects(pagination: $pagination, filters: $filters) {
    count
    collection {
      id
      status
      createdAt
      endsAt
      startsAt
      BSDs {
        count
        collection {
          tdReadableBsdId
          id
          tdState
        }
      }
      isInvoiceable {
        alreadyInvoiced
        errors
        result
      }
      client {
        name
        id
        organization {
          id
        }
      }
      ...AdminFields
      collectedContainers {
        collection {
          id
          quantity
          material {
            id
            name
          }
          container {
            name
            id
          }
        }
      }
      round {
        id
        publicId
      }
      recycler {
        id
        name
        organization {
          id
        }
      }
    }
  }
}
`

export const CANCEL_COLLECT = gql`
mutation CancelCollect($input: CancelCollectInputGraphql!) {
  cancelCollect(input: $input) {
    status
    id
  }
}
`

export const RATE_COLLECT_NPS = gql`
mutation RateCollectNps($input: RateCollectNPSInputGraphql!) {
  rateCollectNPS(input: $input) {
    id
    npsRating {
      additionalDetails
      rating
    }
  }
}
`

export const GET_REFERENTS = gql`
query Referents($filters: UserFilterGraphql!) {
  referents(filters: $filters) {
    collection {
      firstName
      id
      lastName
    }
  }
}
`
